import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { CANCEL_SHIFTS } from '../actions';

const cancelShiftsEpic = (action$, store, { api }) =>
    action$.ofType(CANCEL_SHIFTS).mergeMap(action =>
        Observable.from(action.payload)
            .flatMap(shift => api.cancelShift(shift))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            .catch(() =>
                Observable.of(
                    actions.cancelShiftsFailure('Problem canceling shifts'),
                ),
            ),
    );

const toAction = response => {
    if (response) {
        return actions.cancelShiftSuccess(response.data);
    }
    return actions.cancelShiftsFailure('Problem canceling shifts');
};

export default cancelShiftsEpic;
